(() => {
  const root = document.querySelector('.adorn-brand');
  const header = document.querySelector('#header');
  if (!root || !header) return;
  const sync = () => {
    const height = getComputedStyle(header).position === 'fixed' ? header.getBoundingClientRect().height : 0;
    root.style.setProperty('--adorn-brand-header-height', height + 'px');
  };
  new ResizeObserver(sync).observe(header);
  window.addEventListener('resize', sync);
  sync();
})();
